//R3F
import { PerspectiveCamera } from "@react-three/drei";

function PerspectiveCam() {
  return <PerspectiveCamera position={[0, 10, 200]} makeDefault />;
}

export default PerspectiveCam;
